var map = {
	"./de.json": 688671,
	"./en.json": 917359,
	"./es.json": 850408,
	"./fr.json": 41691,
	"./it.json": 292059,
	"./ja.json": 644035,
	"./ko.json": 7975,
	"./pl.json": 575409,
	"./pt.json": 316130,
	"./ru.json": 208845,
	"./uk.json": 713534
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 244192;